// Shared provider geo data (keyed by exact provider name) + distance helpers.
// Used by both the AustraliaMap and the "Find a provider near you" search.
export const PROVIDER_GEO = {
  "Pure Souls Pet Aqua Cremation": { lat: -19.26, lng: 146.82, city: "Townsville" },
  "Paws to Heaven": { lat: -27.31, lng: 152.98, city: "Brisbane" },
  "The Gentle Way for Pets": { lat: -21.14, lng: 149.19, city: "Mackay" },
  "Hagney Aquamation": { lat: -33.41, lng: 149.58, city: "Bathurst" },
  "Resting Waters": { lat: -38.34, lng: 142.45, city: "Warrnambool" },
  "Blue Leaf Water Cremation": { lat: -32.13, lng: 115.81, city: "Perth" },
  "Pet Water Cremations": { lat: -35.02, lng: 138.6, city: "Adelaide" },
  "Eco Pet Cremations": { lat: -42.88, lng: 147.33, city: "Hobart" },
  "Top End Pet Farewells": { lat: -12.43, lng: 130.93, city: "Darwin" },
};

// Great-circle distance in kilometres between two {lat, lng} points.
export function haversineKm(a, b) {
  const R = 6371;
  const toRad = (d) => (d * Math.PI) / 180;
  const dLat = toRad(b.lat - a.lat);
  const dLng = toRad(b.lng - a.lng);
  const lat1 = toRad(a.lat);
  const lat2 = toRad(b.lat);
  const h =
    Math.sin(dLat / 2) ** 2 +
    Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2;
  return 2 * R * Math.asin(Math.sqrt(h));
}

// Annotate providers with distanceKm from an origin and sort nearest-first.
export function sortByDistance(providers, origin) {
  return providers
    .map((p) => {
      const g = PROVIDER_GEO[p.name];
      const distanceKm = g ? haversineKm(origin, g) : null;
      return { ...p, geo: g || null, distanceKm };
    })
    .sort((a, b) => {
      if (a.distanceKm == null) return 1;
      if (b.distanceKm == null) return -1;
      return a.distanceKm - b.distanceKm;
    });
}

export function formatKm(km) {
  if (km == null) return "";
  if (km < 10) return `${km.toFixed(1)} km away`;
  return `${Math.round(km)} km away`;
}
